import { render, staticRenderFns } from "./MemberConfirm.vue?vue&type=template&id=605a93d2&lang=pug&"
import script from "./MemberConfirm.vue?vue&type=script&lang=js&"
export * from "./MemberConfirm.vue?vue&type=script&lang=js&"
import style0 from "./MemberConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605a93d2')) {
      api.createRecord('605a93d2', component.options)
    } else {
      api.reload('605a93d2', component.options)
    }
    module.hot.accept("./MemberConfirm.vue?vue&type=template&id=605a93d2&lang=pug&", function () {
      api.rerender('605a93d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/MemberConfirm.vue"
export default component.exports